<script lang="ts" setup>
  import { ref, computed } from 'vue'

  interface ProgressBarProps {
    value: number,
    min?: number,
    max?: number,
    height?: number,
    showPercentage?: boolean
    color?: string
  }

  const $props = withDefaults(defineProps<ProgressBarProps>(), {
    min: 0,
    max: 100,
    height: 20,
    showPercentage: true,
    color: 'bg-info'
  })

  const percentage = computed(() => {
    if ($props.value == 0) { return 0 }

    return Math.round(($props.value - $props.min) / ($props.max - $props.min) * 100)
  })

  const progressHeight = computed(() => {
    return `${$props.height}px`
  })

  const progressWidth = computed(() => {
    return `${percentage.value}%`
  })

</script>

<template>
  <div class="progress" :style="{ height: progressHeight }">
    <div
      role="progress"
      class="progress-bar progress-bar-striped"
      :class="`${$props.color}`"
      :style="{ width: progressWidth }"
      :aria-valuenow="$props.value"
      aria-valuemin="0"
      aria-valuemax="100">
        <span v-if="$props.showPercentage">{{ percentage }}%</span>
    </div>
  </div>
</template>